export const TITLE =
  'Request licensing or certification test fees reimbursement online';
export const SUBTITLE =
  'Request for Reimbursement of Licensing or Certification Test Fees (VA Form 22-0803)';
export const OMB_RES_BURDEN = 15;
export const OMB_NUMBER = '2900-0695';
export const OMB_EXP_DATE = '01/31/2028';
